<template>
  <div v-if="ir !== null">
    <!-- Financial Information -->
    <h3>Financial Information</h3>
    <div class="py-5">顯示於Investor Relations頁面</div>

    <div>
      <!-- Title -->
      <div class="form-item d-flex pa-5">
        <div class="w-174px mr-6px"><h4>Title</h4></div>
        <div class="flex-grow-1 flex-basis-0">
          {{ ir.financial_information_title }}
        </div>
      </div>
      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-180px">
          <h4 class="mb-10px">Picture</h4>
        </div>
        <div class="d-flex justify-end flex-grow-1 flex-basis-0">
          <div
            class="bg-cover bg-center w-305px h-187px"
            :style="{
              'background-image': `url(${ir.financial_information_pic||defaultBanner})`,
              'border-radius': '8px',
            }"
          ></div>
        </div>
      </div>
      <div class="px-22px py-5 d-flex">
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex align-center">
          <button
            class="btn w-160px justify-space-between ml-auto mr-n5"
            @click="toEditDetailPage"
          >
            <span>編輯Detail Page</span>
            <v-icon>arrow_forward</v-icon>
          </button>
        </div>
      </div>
    </div>

    <h3 class="mt-5">Tabs</h3>
    <div class="py-5">設定多語系按鈕、頁籤用</div>
    <!-- Items -->
    <div>
      <div
        class="form-item d-flex py-3 align-center"
        v-for="(item, i) in ir.financial_tabs"
        :key="i"
      >
        <div class="h4 ml-5">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ir: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    defaultBanner: 'https://dummyimage.com/305x187.jpg',
  }),
  methods: {
    toEditDetailPage() {
      this.$router.push('/investor-relations/detail-page');
    },
  },
};
</script>

<style></style>
